export const ANALYTIC_ENTITY_TYPES: readonly [
  "ANALYTIC_FOUNDATION",
  "ANALYTIC_COLUMN",
  "ANALYTIC_PORCH",
  "ANALYTIC_FOUNDATION_SUPER_SYSTEM",
  "ANALYTIC_FOUNDATION_HORIZONTAL_ASSEMBLY",
  "ANALYTIC_WALL",
  "ANALYTIC_ROOF",
  "ANALYTIC_CEILING",
  "ANALYTIC_ROOF_SOFFIT",
  "ANALYTIC_DOOR_TRIM",
  "ANALYTIC_WINDOW_TRIM",
  "ANALYTIC_INTERIOR_TRIM",
  "ANALYTIC_RAILING",
  "ANALYTIC_WALL_STRUCTURAL_DOMAIN",
  "ANALYTIC_FLOOR_STRUCTURE",
  "ANALYTIC_EXTERIOR_FINISH_EDGE",
] = [
  "ANALYTIC_FOUNDATION",
  "ANALYTIC_COLUMN",
  "ANALYTIC_PORCH",
  "ANALYTIC_FOUNDATION_SUPER_SYSTEM",
  "ANALYTIC_FOUNDATION_HORIZONTAL_ASSEMBLY",
  "ANALYTIC_WALL",
  "ANALYTIC_ROOF",
  "ANALYTIC_CEILING",
  "ANALYTIC_ROOF_SOFFIT",
  "ANALYTIC_DOOR_TRIM",
  "ANALYTIC_WINDOW_TRIM",
  "ANALYTIC_INTERIOR_TRIM",
  "ANALYTIC_RAILING",
  "ANALYTIC_WALL_STRUCTURAL_DOMAIN",
  "ANALYTIC_FLOOR_STRUCTURE",
  "ANALYTIC_EXTERIOR_FINISH_EDGE",
];

export type BuildingAnalyticEntityType = (typeof ANALYTIC_ENTITY_TYPES)[number];

export function isBuildingAnalyticEntityType(type: string): type is BuildingAnalyticEntityType {
  return ANALYTIC_ENTITY_TYPES.some((analyticType) => analyticType === type);
}

export const ALL_BUILDING_ENTITY_TYPES = [
  ...ANALYTIC_ENTITY_TYPES,
  "ANNOTATION",
  "CASEWORK",
  "CEILING",
  "COLUMN",
  "CORNER_BOARDS",
  "DIMENSION",
  "DOOR",
  "DRIVEWAY",
  "FLOOR_SYSTEM",
  "FOUNDATION_SYSTEM",
  "FOUNDATION_SYSTEM_HORIZONTAL_ASSEMBLY",
  "FOUNDATION_SUPER_SYSTEM",
  "FOUNDATION_STRIP",
  "FOUNDATION_SECTION",
  "SLAB",
  "FOOTING",
  "LUMBER",
  "INTERIOR_TRIM",
  "PORCH",
  "ROOF_SYSTEM",
  "ROOF",
  "ROOF_VOLUME",
  "ROOF_VOLUME_LEGACY",
  "PROP",
  "RAILING",
  "ROOM",
  "SITE",
  "SKYLIGHT",
  "STAIR_SYSTEM",
  "WALL_STRUCTURAL_DOMAIN",
  "WAINSCOTING",
  "WALL_PLANE",
  "BUILDING_GRAPH_PLANAR_TOPOLOGY",
  "WALL_PLANE_SUBDOMAIN",
  "WALL_SYSTEM",
  "WALL",
  "WALL_LAYER",
  "WINDOW",
  "ROOF_FRAMING",
  "ROOF_SOFFIT",
  "FRAMED_FLOOR_ASSEMBLY",
  "SLAB_FLOOR_ASSEMBLY",
  // "ROOF_TRIM",
  // "EXTERIOR_PROP",
  // "INTERIOR_PROP",
  // "RIDGE_VENT",
  // "WINDOW_SHUTTER",
  // "SCREEN",
  // "STAIR",
  // "RIDGE_CAP",
  // "WALL_FRAMING"
  // "GABLE_END_WALL_FRAMING"
] as const;

export type BuildingEntityType = (typeof ALL_BUILDING_ENTITY_TYPES)[number];
